<template>
  <div class="home">
    <innerHeader v-if="!isMobile"></innerHeader>
    <AppHeader v-if="isMobile" />
    <ResponsiveContainer>
      <div class="main">
        <!--cloumnId控制contentList  Tab的active -->
        <contentList
          @tabChagnge="tabChagnge"
          :tabList="tabList"
          :leftTab="5"
          :cloumnId="cloumnId"
          v-if="!isMobile"
          class="bg"
        >
          <div slot="main_content">
            <div class="content_top">
              <div class="article_con">
                <img :src="detail.cover_img" />
              </div>
            </div>
          </div>
        </contentList>
        <AppcontentList
          @tabChagnge="tabChagnge"
          :tabList="tabList"
          :leftTab="5"
          :cloumnId="cloumnId"
          :contentBg="contentBg2"
          v-if="isMobile"
          class="appbg"
        >
          <div slot="main_content">
            <div class="app_content_top">
              <div class="article_con article_con_in">
                <img :src="detail.cover_img" />
              </div>
            </div></div
        ></AppcontentList>
        <!-- <paginations
          :current-page.sync="page.current"
          @current-change="currentChange"
          :page-size="page.size"
          :total="page.total"
        ></paginations> -->
      </div>
    </ResponsiveContainer>
    <Footer v-if="!isMobile" />
    <innerAppFooter v-else />
  </div>
</template>

<script>
import innerHeader from '@/components/innerHeader.vue';
import AppHeader from '@/components/AppHeader';
import Footer from '@/components/Footer.vue';
import innerAppFooter from '@/components/innerAppFooter';
import ResponsiveContainer from '@/components/ResponsiveContainer';
import contentList from '@/components/contentList';
import AppcontentList from '@/components/AppcontentList';
import paginations from '@/components/Pagination.vue';
import responsiveMixin from '@/mixins/responsiveMixin';
import { moreTab } from '@/const';
import { getPageObj } from '@/assets/api';
export default {
  name: 'Memento',
  mixins: [responsiveMixin],
  components: {
    innerHeader,
    AppHeader,
    innerAppFooter,
    Footer,
    ResponsiveContainer,
    contentList,
    AppcontentList,
    paginations,
  },
  data() {
    return {
      contentBg: require('../../assets/img/homeimgs/presi_bg.png'),
      contentBg2: require('../../assets/img/appImg/presi_bg.png'),
      currentIndex: 0,
      tabList: moreTab,

      cloumnId: '1946499297547960322', //栏目id
      detail: {},
      id: '',
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    tabChagnge(column, cloumnId) {
      this.cloumnId = cloumnId;
      this.$router.push({ path: column.accessPath });
      // this.getList();
    },
    currentChange(e) {
      this.current = e;
      // this.getList();
    },
    getDetail() {
      getPageObj(this.cloumnId).then((res) => {
        if (res.code == 200) {
          this.detail = res.data;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.main {
  .content_top {
    padding: 1.5rem 0;
    .article_con {
      width: 100%;
      box-sizing: border-box;
      img {
        width: 100%;
      }
    }
  }
  .app_content_con {
    background: #fff;
  }
  .app_content_top {
    background: #fff;
    margin: 2rem 0;
    min-height: 53.4vh;
    .article_con {
      background: #fff;
      width: 100%;
      box-sizing: border-box;

      .contact_item {
        margin-top: 1.3333rem;
        width: 100%;
        padding: 1rem 1.9167rem;
        box-sizing: border-box;
        background: #f3f3f3;
        border-left: 0.3125rem solid;
        border-image: linear-gradient(
            180deg,
            rgba(170, 229, 239, 1),
            rgba(177, 187, 255, 1)
          )
          6 6;
        display: flex;
        flex-direction: column;
        justify-content: center;
        color: #6b6d7a;
        font-size: 1rem;
      }
    }
  }
}
::v-deep {
  .article_con_in {
    img {
      width: 100% !important;
      height: auto;
    }
  }
}
.appbg {
  width: 100%;
  background: url('../../assets/img/appImg/presi_bg.png') no-repeat left
    bottom/100% auto;
}
.bg {
  width: 100%;
  background: url('../../assets/img/homeimgs/article_bg.png') no-repeat left
    bottom/100% auto;
}
</style>
